import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Tutor} from "./tutor";


const routes: Routes = [
  {
    path: 'tutors',
    component: Tutor,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TutorRoutingModule {}
